<template>
  <a-form-item
    v-if="data && data.fieldkey"
    :label="data.fieldname"
    class="select-tree"
  >
    <div
      v-decorator="[`${data.fieldkey}`, {
        trigger: [],
        rules: [{
          required: data.isneeded === 1 ? true : false,
          message: ' '
        }, {
          validator: checkValue
        }],
        initialValue: data.fieldvalue
      }]"
      class="wrap"
    >
      <a-tree-select
        v-if="treedata && treedata.length"
        dropdown-class-name="inquiry-select-tree-drop"
        :default-value="value"
        :tree-data="treedata"
        :placeholder="placeholder"
        allow-clear
        :show-search="treedata && treedata.length ? true : false"
        :multiple="multiple"
        tree-default-expand-all
        tree-node-filter-prop="title"
        :get-popup-container="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }
        "
        @change="onChange"
      />
      <div
        v-if="fieldconfig.enableinput"
        class="box"
      >
        <span
          v-if="treedata && treedata.length"
          class="label"
        >{{ $t('message["451"]') }}</span>
        <a-input
          v-model="input"
          :placeholder="enterPlaceholder"
          class="input"
          @input="onInput"
        />
      </div>
    </div>
    <!-- <a-tree-select
      v-if="treedata"
      :ref="`${data.fieldkey}-tree-select`"
      :value="value"
      :tree-data="treedata"
      :dropdown-style="{
        maxHeight: '400px',
        overflow: 'auto'
      }"
      :placeholder="placeholder"
      allow-clear
      :multiple="multiple"
      tree-default-expand-all
      @change="onChange"
      @search="onSearch"
      @select="onSelect"
    /> -->
  </a-form-item>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    getData: {
      type: Function,
      default: () => { }
    }
  },
  inject: ['myForm'],
  data () {
    return {
      input: '',
      value: [],
      treedata: [],
      treedataObj: {
        children: {}
      }
    }
  },
  computed: {
    fieldconfig () {
      const { fieldconfig = {} } = this.data
      return fieldconfig
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  async created () {
    if (!this.data) return

    const { data = {} } = this
    let { fieldvalue = {}, options = [] } = data
    const { treedata = [], input = '' } = fieldvalue

    this.value = treedata
    this.input = input

    if (!options || !options.length) {
      options = await this.loadData() || []
    }

    for (let item of options) {
      item.pId = '0'
      item.pName = ''
    }
    this.setOptions(options)

    this.setObjTreedata(this.treedataObj.children, this.treedata)
    // console.log(this.data.fieldname, this.treedataObj)
  },
  methods: {
    /* async init () {
      if (!this.data) return

      const { data = {} } = this
      let { fieldvalue = {} } = data
      const { treedata = [], input = '' } = fieldvalue

      this.value = treedata
      this.input = input
    }, */
    async loadData () {
      const { fieldkey = '' } = this.data || {}

      const data = await this.getData({ fieldkey }) || []

      return data
    },
    setOptions (options) {
      for (let item of options) {
        item.title = item.name
        // item.value = item.pId + '-' + item.id
        item.value = item.id
        item.key = item.pId + '-' + item.id
        if (item.children || item.child) {
          item.children = item.children || item.child || []
          for (let child of item.children) {
            child.pId = item.pId + '-' + item.id
            child.pName = item.pName + '/' + item.name
          }
          this.setOptions(item.children)
        }
      }
      this.treedata = options
    },
    onChange (value) {
      this.value = value
      this.data.fieldvalue.input = this.input
      this.data.fieldvalue.treedata = this.value
      const { fieldkey, fieldvalue } = this.data
      this.myForm.setFieldsValue({
        [fieldkey]: fieldvalue
      })
      this.myForm.validateFields([fieldkey], this.validatedCallback)
    },
    onInput (val) {
      this.data.fieldvalue.input = this.input
      this.data.fieldvalue.treedata = this.value
      // this.$emit('change', this.data.fieldvalue)
      const { fieldkey, fieldvalue } = this.data
      this.myForm.setFieldsValue({
        [fieldkey]: fieldvalue
      })
      this.myForm.validateFields([fieldkey], this.validatedCallback)
    },
    onSelect () {
      console.log(...arguments)
    },
    setObjTreedata (obj, options) {
      for (let item of options) {
        obj[item.id] = {}
        obj[item.id].name = item.name
        if (item.children) {
          obj[item.id].children = {}
          this.setObjTreedata(obj[item.id].children, item.children)
        }
      }
    },
    validatedCallback (err, values) {
      if (!err) {
        this.$emit('change', this.data.fieldvalue)
      }
    },
    checkValue (rule, value = {}, callback) {
      // console.log('arg: ', arguments)
      const { enableinput } = this.fieldconfig || {}
      const { isneeded } = this.data || {}
      if (!isneeded) {
        callback()
      } else {
        const { treedata = [], input = '' } = value
        const length = treedata.length
        if (enableinput) {
          if (input) {
            callback()
          } else {
            if (length) {
              callback()
            } else {
              callback(new Error(`${this.$t('message["865"]')}${this.data.fieldname}`))
            }
          }
        } else {
          if (length) {
            callback()
          } else {
            callback(new Error(`${this.$t('message["855"]')}${this.data.fieldname}`))
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select-tree {
  .ant-select {
    margin-bottom: 24px;
  }
  .ant-input {
    display: inline-block;
  }
  .box {
    position: relative;
    .label {
      margin-left: -140px;
      width: 140px;
      display: inline-block;
      text-align: right;
      padding-right: 25px;
    }
  }
}
</style>
<style lang="scss">
// 树形下拉最大高度
.inquiry-select-tree-drop {
  .ant-select-tree {
    max-height: 300px;
  }
}

</style>
